<template>
  <div ref="app" id="app">
    <div class="headBar">
      <span v-for="item in tabs" :key="item.name" :class="tab === item.tab ? 'hh' : ''" @click=changeTab(item.tab,item.path)>{{item.name}}</span>
    </div>
    <router-view ref="child" />
    <div class="footer">
      <span @click="openWindow">
        浙ICP备2022032219号-1
      </span>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "App",
  data(){
    return{ 
      tab: 1,
      tabs: [
        {
          tab: 1,
          name: '首页',
          path: '/'
        },
        {
          tab: 2,
          name: '公司介绍',
          path: 'info'
        },
        {
          tab: 3,
          name: '小安商学院',
          path: 'school'
        },
        {
          tab: 4,
          name: '联系我们',
          path: 'connect'
        },
      ]
    }
  },
  // computed:{
  //   keepAlive({
  //     return 
  //   }
  // },
  mounted() {
    let vh = document.documentElement.clientHeight;

    window.screenWidth = document.body.clientWidth;
    // if (window.screenWidth < 769) {
    //   // 计算移动端可见屏幕高度
    //   this.$store.commit("GET_DEVICE_TYPE", true);
    // } else {
    //   this.$store.commit("GET_DEVICE_TYPE", false);
    // }
    // window.onresize = () => {
    //   return (() => {
    //     window.screenWidth = document.body.clientWidth;
    //     if (window.screenWidth < 769) {
    //       this.$store.commit("GET_DEVICE_TYPE", true);
    //     } else {
    //       this.$store.commit("GET_DEVICE_TYPE", false);
    //     }
    //   })();
    // };
  },
  methods: {
    resize() {
      try {
        if (typeof eval(this.$refs.child.callResize) === "function") {
          this.$refs.child.callResize();
        }
      } catch (e) {}
    },
    changeTab(tab, path) {
      this.tab = tab;
      this.$router.push(path);
    },
    openWindow() {
      window.open('https://beian.miit.gov.cn/')
    }
  }
};
</script>

<style lang="scss">
@media (min-width: 769px) {
  #app {
    min-height: 100vh;
    .headBar{
      height: 50px;
      width: 100%;
      background-color: rgb(234, 230, 230);
      display: flex;
      position: fixed;
      top: 0;
      z-index: 99;
      span{
        width: 10%;
        color: #333333;
        line-height: 50px;
        text-align: center;
        cursor: pointer;
        &:hover{
          color: rgb(18, 137, 216);
        }
      }
      .hh{
        color: rgb(18, 137, 216);
      }
    }
    .footer{
      position: fixed;
      bottom: 0;
      color: #999;
      height: 50px;
      width: 100%;
      text-align: center;
      // background-color: rgb(234, 230, 230);
      background-color: #fff;
      span{
        line-height: 50px;
      }
    }
  }
}
</style>
